import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import StyledSection from "components/global/Section";
import { InnerSectionContainer } from "components/global/Container";
import {
  InputLabel,
  FormRow,
  TextInput,
  CancelButton,
  SubmitButton,
  StyledCheckbox,
} from "components/global/forms";
import {
  addClient,
  isConnectionTypeDropdownEnabled,
} from "data/features/clients/clientsApi";
import { useTranslation } from "react-i18next";
import { Heading, ButtonsContainer } from "../styles";

export const AddClient = () => {
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(true);
  const [isEnabledConnectionTypeDropdown, setIsEnabledConnectionTypeDropdown] =
    useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    isConnectionTypeDropdownEnabled()
      .then((response) =>
        setIsEnabledConnectionTypeDropdown(response.data.isWorkingCopyEnabled)
      )
      .catch((error) => {
        setError("showWorkingCopy", {
          type: "custom",
        });
        console.error(error);
        setIsEnabledConnectionTypeDropdown(false);
      });
  });

  const onSubmit = (data) => {
    setIsDisabled(true);
    addClient({
      name: data.clientName.trim(),
      status: data.status ? "ACTIVE" : "NOT_ACTIVE",
      showWorkingCopy: data.showWorkingCopy,
    })
      .then((response) => {
        navigate("/clients", { replace: true });
        return response;
      })
      .catch((error) => {
        setError("clientName", {
          type: "custom",
        });
        toast.error(error.response.data.message);
        return error;
      });
  };

  useEffect(() => {
    const subscription = watch((value) => {
      const isFieldFilled = value.clientName.trim().length;
      setIsDisabled(!isFieldFilled);
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <StyledSection type="login">
      <InnerSectionContainer>
        <Heading>{t("addClient.heading")}</Heading>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormRow bottomSpace>
            <InputLabel lead>{t("addClient.form.name.label")}*</InputLabel>
            <TextInput
              aria-label="ClientName"
              hasError={errors.clientName}
              {...register("clientName", {
                required: t("addClient.form.name.required"),
              })}
            />
          </FormRow>
          <FormRow>
            <InputLabel lead>{t("form.active.label")}</InputLabel>
            <div>
              <StyledCheckbox
                {...register("status")}
                defaultChecked
                color="success"
              />
            </div>
          </FormRow>
          {isEnabledConnectionTypeDropdown && (
            <FormRow>
              <InputLabel lead>
                {t("form.showConnectionTypeDropdown.label")}
              </InputLabel>
              <div>
                <StyledCheckbox
                  {...register("showWorkingCopy")}
                  color="success"
                />
              </div>
            </FormRow>
          )}
          <ButtonsContainer>
            <CancelButton aria-label="CancelAddClientButton" to="/clients">
              {t("form.cancel")}
            </CancelButton>
            <SubmitButton
              aria-label="AddClientButton"
              disabled={isDisabled}
              type="submit"
            >
              {t("form.save")}
            </SubmitButton>
          </ButtonsContainer>
        </form>
      </InnerSectionContainer>
    </StyledSection>
  );
};
